<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.teachers', 2),
                        href: meta.links.index,
                    },
                    {
                        name: teacher.full_name,
                        href: null,
                    },
                    {
                        name: $tc('messages.roles', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $tc('messages.roles', 2) }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <div v-for="role in form.roles" :key="role.text">
                                <button
                                    type="button"
                                    @click="role.active = !role.active"
                                    :class="role.active ? 'bg-indigo-600' : 'bg-gray-200'"
                                    class="relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    role="switch"
                                    aria-checked="false"
                                >
                                    <span class="sr-only">role</span>
                                    <span
                                        :class="role.active ? 'translate-x-5' : 'translate-x-0'"
                                        aria-hidden="true"
                                        class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition ease-in-out duration-200"
                                    ></span>
                                </button>
                                {{ role.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['teacher', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                roles: this.teacher.roles,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
